import { RouteObject } from "react-router-dom";
import { LoginPage } from "./ui/LoginPage";

export const loginRoute: RouteObject = {
  path: "/login",
  element: <LoginPage />,
};
